import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { eSize } from '../k-cards/k-cards.component';

@Component({
  selector: 'rank',
  templateUrl: './rank.component.html',
  styleUrls: ['./rank.component.scss']
})
export class RankComponent implements OnInit, OnChanges {

  _starFullPath: string = 'assets/img/Icon/Star-Full.svg';
  _starHalfPath: string = 'assets/img/Icon/Star-Half.svg';
  _starEmptyPath: string = 'assets/img/Icon/Star-Empty.svg';
  @Input() ranking: number = 0;
  @Input() shape: eShape = eShape.rectangle;
  @Input() size: eSize = eSize.sm;
  arrayStar: string[] = [];
  _label: string;

  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.ranking > -1 && this.shape) {
      let starNumber: number;
      let halfStar: boolean = false;
      let emptyArray: string[] = [];

      // if (this.ranking < 625) {
      //   this._label = 'ROOKIE';
      //   starNumber = 1;
      // }
      // if (this.ranking >= 625 && this.ranking < 650) {
      //   this._label = 'ROOKIE';
      //   starNumber = 1;
      //   halfStar = true;
      // }
      // if (this.ranking >= 650 && this.ranking < 675) {
      //   this._label = 'VETERAN';
      //   starNumber = 2;
      // }
      // if (this.ranking >= 675 && this.ranking < 700) {
      //   this._label = 'VETERAN';
      //   starNumber = 2;
      //   halfStar = true;
      // }
      // if (this.ranking >= 700 && this.ranking < 725) {
      //   this._label = 'ELITE';
      //   starNumber = 3;
      // }
      // if (this.ranking >= 725 && this.ranking < 750) {
      //   this._label = 'ELITE';
      //   starNumber = 3;
      //   halfStar = true;
      // }
      // if (this.ranking >= 750 && this.ranking < 775) {
      //   this._label = 'ELITE';
      //   starNumber = 4;
      // }
      // if (this.ranking >= 775 && this.ranking < 800) {
      //   this._label = 'HERO';
      //   starNumber = 4;
      //   halfStar = true;
      // }
      // if (this.ranking >= 800) {
      //   this._label = 'HERO';
      //   starNumber = 5;
      // }
      let rankInfo: IRankValue = getRankInfo(this.ranking);
      this._label = rankInfo.label;
      starNumber = rankInfo.starNumber;
      halfStar = rankInfo.halfStar;
      this.arrayStar = Array(starNumber).fill(this._starFullPath);
      if (halfStar) this.arrayStar.push(this._starHalfPath);
      emptyArray = Array(5 - this.arrayStar.length).fill(this._starEmptyPath);
      this.arrayStar = this.arrayStar.concat(emptyArray);
    }
  }
}

export enum eShape {
  rectangle = 'rectangle',
  rounded = 'rounded'
}

export enum eRank {
  ROOKIE = 'ROOKIE',
  VETERAN = 'VETERAN',
  ELITE = 'ELITE',
  HERO = 'HERO'

}

export const RANK_DATA = (): IRankValue[] => {
  return [
    {
      label: eRank.ROOKIE,
      starNumber: 1,
      halfStar: false,
      rankMin: 0,
      rankMax: 625
    },
    {
      label: eRank.ROOKIE,
      starNumber: 1,
      halfStar: true,
      rankMin: 625,
      rankMax: 650
    },
    {
      label: eRank.VETERAN,
      starNumber: 2,
      halfStar: false,
      rankMin: 650,
      rankMax: 675
    },
    {
      label: eRank.VETERAN,
      starNumber: 2,
      halfStar: true,
      rankMin: 675,
      rankMax: 700
    },
    {
      label: eRank.ELITE,
      starNumber: 3,
      halfStar: false,
      rankMin: 700,
      rankMax: 725
    },
    {
      label: eRank.ELITE,
      starNumber: 3,
      halfStar: true,
      rankMin: 725,
      rankMax: 750
    },
    {
      label: eRank.ELITE,
      starNumber: 4,
      halfStar: false,
      rankMin: 750,
      rankMax: 775
    },
    {
      label: eRank.HERO,
      starNumber: 4,
      halfStar: true,
      rankMin: 775,
      rankMax: 800
    },
    {
      label: eRank.HERO,
      starNumber: 5,
      halfStar: false,
      rankMin: 800,
      rankMax: 9999999
    },
  ]
}

export const getRankInfo = (rank: number): IRankValue => {
  return RANK_DATA().filter(i => rank >= i.rankMin && rank < i.rankMax)[0]
}

export const getRankMinMax = (rank: eRank): number[] => {
  let range: IRankValue[] = RANK_DATA().filter(r => r.label == rank);
  return [range[0].rankMin, range[range.length - 1].rankMax];
}

export interface IRankValue {
  label: eRank
  starNumber: number
  halfStar: boolean
  rankMin: number
  rankMax: number
}